// SWR's default cache is a Map<any, any>; you can adjust this if needed.
export const localStorageProvider = () => {
    // Retrieve the stored cache from localStorage (if any)
    const stored = localStorage.getItem("app-cache");
    // Initialize a new Map with the stored entries or an empty array
    const map = new Map(stored ? JSON.parse(stored) : []);
    // Before the page unloads, persist the cache to localStorage.
    window.addEventListener("beforeunload", () => {
        const appCache = JSON.stringify(Array.from(map.entries()));
        localStorage.setItem("app-cache", appCache);
    });
    return map;
};
